const urls = {
  fetchDocketData(code: string) {
    return `consignment/getDocket?cCode=${code}`;
  },
  deleteDocket(argArr: Array<string>) {
    return `/consignment/deleteDocket?${argArr.join('&')}`;
  },
  fetchCollectionEnums() {
    return `/trips/collection/enums`;
  },
  updateConsignment() {
    return `/driver/updateConsignment`;
  },
  saveCollection() {
    return `/trips/collection`;
  },
  saveDocket() {
    return `/consignment/saveDocket`;
  },
  fetchFilters() {
    return `/vehicle/scheduledFilter`;
  },
  fetchScheduledMapData(argArr: Array<string>) {
    return `/vehicle/aggregatedMapDataForSchedule?${argArr.join('&')}`;
  },
  findConsignee(code: string) {
    return `/consignee/findConsigneeForConsignment?cCode=${code}`;
  },
  fetchCollectionData(code: string) {
    return `/trips/collection?code=${code}`;
  },
  fetchScheduledVehicles(argArr: Array<string>) {
    return `/vehicle/scheduled?${argArr.join('&')}`;
  },
  fetchPathDetail(argArr: Array<string>) {
    return `/vehicle/getPathDetail?${argArr.join('&')}`;
  },
  validateActionTime(argArr: Array<string>) {
    return `/consignment/validateActionTime?${argArr.join('&')}`;
  },
  fetchScheduledItenary(argArr: Array<string>) {
    return `/vehicle/getItinerary?${argArr.join('&')}`;
  },
  fetchScheduledCount(argArr: Array<string>) {
    return `/vehicle/scheduledCounts?${argArr.join('&')}`;
  },
  deleteTrip(argArr: Array<string>) {
    return `/admin/consignment/delete?${argArr.join('&')}`;
  },
  getCurrentLocation(argArr: Array<string>) {
    return `/vehicle/getCurrentLocation?${argArr.join('&')}`;
  },
  deleteInvoice(invoiceId: any) {
    return `/consignment/deleteInvoice?invoiceId=${invoiceId}`;
  },
};

export default urls;
